module.exports = __webpack_public_path__ + "img/back10.6583ef59.png";